import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Plans from './components/Plans';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import OurClients from './components/OurClients';
import Demo from './components/Demo';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import Privacy from './components/Privacy';

function HomePage() {
  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <Plans />
      <HowItWorks />
      <OurClients />
      <Demo />
      <Testimonials />
      <AboutUs />
      <FinalCTA />
      <Footer />
    </>
  );
}

function PrivacyPage() {
  return (
    <>
      <Navbar />
      <Privacy />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="font-sans text-gray-900 bg-white">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
